import { styled } from '../../Utilities';
import { ShimmeredDetailsListBase } from './ShimmeredDetailsList.base';
import { getStyles } from './ShimmeredDetailsList.styles';
export var ShimmeredDetailsList = styled(ShimmeredDetailsListBase, getStyles, undefined, {
  scope: 'ShimmeredDetailsList'
});